import { collectionsService } from '@services/firebase/firestore/functionFactory';
import { InitialDataService } from '@services/loadInitialData';
import { PermissionsService } from '@services/permissions';
import { appUserStore } from '@stores/bootstrap-stores/user';
import { hasItems } from '@utils/vanillaJs';
import { collectionRef, Member, UserGroup } from '@vincerosoft/assessfluence-types';
import { where } from 'firebase/firestore';
import { defaultDataModels } from 'src/constants/initDataModels';

function userGroupsFactory() {
  function createEmptyUserGroup(member: Member) {
    return defaultDataModels().userGroup(member.id);
  }

  async function loadUserGroupsStore(onProgress: (userGroups: UserGroup[]) => void) {
    const { currentMember: member, role } = appUserStore.getState();
    const canRead = PermissionsService.canRead('user-group');

    if (!canRead) {
      return null;
    }

    if (role?.user_type === 'admin') {
      let ugs: UserGroup[] = [];
      await InitialDataService.load(
        collectionRef.userGroups,
        [where('entity_id', '==', member!.entity_id)],
        {},
        (compoundedData: UserGroup[]) => {
          ugs = compoundedData;
          onProgress(compoundedData);
        }
      );
      return ugs;
    }

    // users with only user group read access should only see user groups they are a part of
    const userGroupIds = member?.user_group_ids || [];
    if (userGroupIds.length === 0) {
      return [];
    }

    const ugs = await getUserGroupsByIds(userGroupIds, (ugs) => onProgress(ugs));
    return ugs;
    // return userGroups
  }

  const getUserGroupsByIds = async (
    ids: string[],
    onProgress?: (userGroups: UserGroup[]) => void
  ) => {
    if (!hasItems(ids)) {
      return [];
    }
    const userGroups = await collectionsService.userGroups.getDocsInBatches(
      ['id', 'in', ids],
      undefined,
      onProgress
    );
    return userGroups.flat();
  };

  return {
    createEmptyUserGroup,
    loadUserGroupsStore,
    getUserGroupsByIds
  };
}

export const userGroupsService = userGroupsFactory();
